import React, { useContext, useEffect, useState, PropsWithChildren } from 'react';
import { getApiToken, getApiTokens } from '../../utils/cob-utils';

export interface IApiTokenContext {
    getTokenString: (key: string) => string,
    apiTokenMap: Record<string, any>
}

export const ApiTokenContext = React.createContext<IApiTokenContext>({
    getTokenString: () => {
        throw 'ApiTokenContext not initialised properly';
    },
    apiTokenMap: {},
});

export const useApiTokenContext = () => useContext(ApiTokenContext);

export const ApiTokenProvider = (props: PropsWithChildren<{}>) => {

    const [apiTokenMap, setApiTokenMap] = useState<Record<string, any>>({});

    useEffect(() => {
        const apiTokens = getApiTokens();
        setApiTokenMap(apiTokens);
    }, []);

    const getTokenString = (keyToGet: string): string => {
        if (!Object.entries(apiTokenMap).length) {
            return null;
        }
        const toReturn = getApiToken(keyToGet);
        return toReturn as string;
    };

    return (
        <ApiTokenContext.Provider value={{
            getTokenString,
            apiTokenMap,
        }}>
            {props.children}
        </ApiTokenContext.Provider>
    );
};